import BeachesAPI from "../../api/BeachesAPI";

export function getBeachDetails(id, language) {
  return function(dispatch) {
    dispatch({ type: "GET_BEACH_DETAILS_LOADING" });
    return BeachesAPI.getBeachDetails(id, language).then(data => {
      dispatch({
        type: "GET_BEACH_DETAILS_SUCCESS",
        beach_details: data.data.beach_details,
        meteo : data.data.meteo
      });
    });
  };
}

export function setBeachDetails(beach_details) {
  return function(dispatch) {
      dispatch({
        type: "SET_BEACH_DETAILS",
        beach_details: beach_details,
      });
  };
}



export function getSeason() {
  return function(dispatch) {
    //dispatch({ type: "GET_SEASON_LOADING" });
    return BeachesAPI.getSeason().then(data => {
      dispatch({
        type: "GET_SEASON_SUCCESS",
        season: data.data.season
      });
    });
  };
}


export function getBeaches(language) {
  return function(dispatch) {
    dispatch({ type: "GET_BEACHES_LIST_LOADING" });
    return BeachesAPI.getBeaches(language).then(data => {

      var allBeachesClosedTmp = true;
      if (data.data.beaches_list && data.data.beaches_list !== null) {
        for (const property in data.data.beaches_list) {
          if (
            data.data.beaches_list[property]['color'] !== 0 &&
            data.data.beaches_list[property]['color'] !== 5
          ) {
            allBeachesClosedTmp = false;
          }
        }
      } else {
        allBeachesClosedTmp = false;
      }

    

      dispatch({
        type: "GET_BEACHES_LIST_SUCCESS",
        beaches_list: data.data.beaches_list,
        risks : data.data.risks,
        allBeachesClosed: allBeachesClosedTmp,
      });

    });
  };
}


export function toggleFavorites(id_beach) {
  return function(dispatch) {
    dispatch({
      type: "TOGGLE_FAVORITES",
      id_beach: id_beach
   });
  };
}

export function initFavoritesBeaches(favorites) {
  return function(dispatch) {
    dispatch({
      type: "INIT_FAVORITES",
      favorites: favorites
   });
  };
}

export function initNotifications(notifications) {
  return function(dispatch) {
    dispatch({
      type: "INIT_NOTIFICATIONS",
      notifications: notifications
   });
  };
}


export function sendFilters(beaches_filters) {
  return function(dispatch) {
    dispatch({
      type: "SEND_FILTERS",
      beaches_filters: beaches_filters
   });
  };
}

export function launchTutoriel() {
  return function(dispatch) {
    dispatch({
      type: "LAUNCH_TUTORIEL"
   });
  };
}

export function removeFilter(filterName) {

  return function(dispatch) {
    dispatch({
      type: "REMOVE_FILTER",
      filterName: filterName
   });
  };
}
